import { strings } from 'APP_ROOT/localization';

export default class MapboxPolygonGeofenceControl {


    polygonDrawButtonCallback;
    polygonTrashButtonCallback;
    closeOnboardingMessageCallback;
    showOnboardingMessage;
    disableDrawBtn;
    disableTrashBtn;

    constructor(callbackForPolygonDrawButtonEventListener, callbackForPolygonTrashButtonEventListener, callbackForCloseOnboardingMessageEventListener, disableDrawBtn, disableTrashBtn, showOnboardingMessage) {
        this.polygonDrawButtonCallback = callbackForPolygonDrawButtonEventListener;
        this.polygonTrashButtonCallback = callbackForPolygonTrashButtonEventListener;
        this.closeOnboardingMessageCallback = callbackForCloseOnboardingMessageEventListener;
        this.showOnboardingMessage = showOnboardingMessage;
        this.disableDrawBtn = disableDrawBtn;
        this.disableTrashBtn = disableTrashBtn;
    }

    polygonDrawButtonEventListener = () => {
        this.polygonDrawButtonCallback();
    }

    polygonTrashButtonEventListener = () => {
        this.polygonTrashButtonCallback();
    }

    closeMessageButtonEventListener = (e) => {
        e.preventDefault();
        const onboardingMsgElement = document.getElementById('drawPolygonOnboardingMsg');
        onboardingMsgElement.style.display = 'none';
        this.closeOnboardingMessageCallback();
    }

    onAdd(map) {
        this.map = map;
        this.container = this.container();
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {
        const style = 'width: 30px; padding: 3px;'; /* using padding to shrink the icon down while keeping overall width 30px */
        const disabledStyle = 'width: 30px; padding: 3px; opacity: 0.5;'; /* using padding to shrink the icon down while keeping overall width 30px */

        // polygon btn
        var polygonImageElement = document.createElement('img');
        polygonImageElement.src = '/images/map-btn-polygon.svg';
        polygonImageElement.style = this.disableDrawBtn ? disabledStyle: style ; 

        var polygonButtonElement = document.createElement('button');
        polygonButtonElement.id = 'drawPolygonBtn';
        polygonButtonElement.disabled = this.disableDrawBtn;
        polygonButtonElement.title = strings.map_controls_label_draw_polygon;
        polygonButtonElement.appendChild(polygonImageElement);

        polygonButtonElement.addEventListener('click', this.polygonDrawButtonEventListener);

        // trash btn
        var trashBtnImageElement = document.createElement('img');
        trashBtnImageElement.src = '/images/map-btn-trash.svg';
        trashBtnImageElement.style = this.disableTrashBtn ? disabledStyle: style ; 

        var trashButtonElement = document.createElement('button');
        trashButtonElement.id = 'drawPolygonBtn';
        trashButtonElement.disabled = this.disableTrashBtn;
        trashButtonElement.title = strings.map_controls_label_trash;
        trashButtonElement.appendChild(trashBtnImageElement);

        trashButtonElement.addEventListener('click', this.polygonTrashButtonEventListener);        

        var buttonWrapper = document.createElement('div');
        buttonWrapper.style = "position: relative;";
        buttonWrapper.appendChild(polygonButtonElement);
        buttonWrapper.appendChild(trashButtonElement);

        // onboarding message
        var onboardingMsgElement = document.createElement('div');

        if(this.showOnboardingMessage) {
            // close message button
            var closeMessageButtonElement = document.createElement('a');
            closeMessageButtonElement.className = 'closeMessageBtn';
            closeMessageButtonElement.innerHTML = " × ";

            closeMessageButtonElement.addEventListener('click', this.closeMessageButtonEventListener);

            // arrow + message
            var MessageElement = document.createElement('span');
            MessageElement.innerHTML = "<span>" + strings.geofence_polygon_onboarding + " ▶ </span>";

            // onboarding message container
            onboardingMsgElement.id = 'drawPolygonOnboardingMsg';
            onboardingMsgElement.className = "mapboxgl-polygon-onboarding";
            onboardingMsgElement.appendChild(closeMessageButtonElement);
            onboardingMsgElement.appendChild(MessageElement);
            
        }

        buttonWrapper.appendChild(onboardingMsgElement);


        return buttonWrapper;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}